import React from "react";
import { useDispatch } from "react-redux";
import { changePage } from "../../../actions/navigationActions";

const TableRow = ({ rowData }) => {
  const dispatch = useDispatch();

  const setPage = () => {
    dispatch(changePage(rowData.page));
  };

  return (
    <div className="content-row" onClick={setPage}>
      <div className="row-data section">{rowData.section}</div>
      <div className="row-data name">{rowData.name}</div>
      <div className="row-data details">
        {" "}
        <span>{rowData.details}</span>
      </div>
      <div className="row-data page">{rowData.page}</div>
    </div>
  );
};

export default TableRow;
